import { Card, CardContent, CardHeader } from "@material-ui/core";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";



const ProductivityChart = (props) => {
 

  return (
    <div>
      <Card style={{width:"100%",height:"100%",}} >
        <CardHeader data-testid="chart-header-Id" subheader={props.title} style={{textAlign:"center" ,fontSize:"12px"}}       titleTypographyProps={{variant:'body1' }}/>
       <CardContent>
       <ResponsiveContainer width={"100%"} height={270}>
        <LineChart
            width={500}
            height={220}
            data={props.data}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" style={{fontSize:"12px"}} interval={0}/>
            <YAxis  label={{ value: props.values.yAxisLabel, angle: -90, dy:10, dx:-20 ,}} interval={0}  style={{fontSize:"12px"}}  />
            <Tooltip />
            <Legend />
            <Line data-testid="chart-linear1-id" name={props.values.line1Plot} type="linear" dataKey={props.values.line1DataKey} stroke={props.values.line1Color} strokeWidth={3} />
            <Line name= {props.values.line2Plot} type="linear" dataKey={props.values.line2DataKey}stroke={props.values.line2Color} strokeWidth={3}/>
          </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProductivityChart;
